export const features = {
  intake : "Intake",
  demographicAttachments: "DemographicsAttachments",
  apricotIntakeV1_1 : "ApricotIntakeV1.1",
  apricotPortal: "ApricotPortal",
  apricotPortalTier2: "ApricotPortalTier2",
  /** the feature toggle that determines if dashboard messages should be shown for Apricot users */
  apricotPortalDashboardMessages: "ApricotPortalDashboardMessages",
  /** feature that enables/desables the 'Direct Messages' pages */
  directMessages: 'DirectMessages',
  apricotPortalFormPermissionsEdit: 'ApricotPortalFormPermissionsEdit',
  connectScheduler: 'ConnectScheduler'
};



// WEBPACK FOOTER //
// src/features/feature.constants.js